import { Input } from "@/components/ui/input";
import {
  setMyMargin,
  setPartnerMargin,
  setRefundableAmount,
  setRefundSettlementRate,
} from "redux/features/RefundOrder";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { toast } from "sonner";

export function calculateProfit(amountUSD: number, rate: number, margin: number) {
  const sellingRate = rate + margin;
  const receivedINR = amountUSD * sellingRate;
  const costINR = amountUSD * rate;
  const profit = receivedINR - costINR;
  return profit;
}
export default function Step2() {
  const {
    refundable_amount,
    my_margin,
    partner_margin,
    settlement_rate,
    amount_sent,
    currency,
    partner_order_id,
  } = useAppSelector((state) => state.CreateRefundOrder);
  const dispatch = useAppDispatch();


  return (
    <div className="flex md:flex-1 flex-col gap-5 md:h-auto items-start justify-start sm:px-0 md:px-5 w-[53%] md:w-full">
      <div className="flex sm:pl-0 pl-10 flex-col gap-10 items-start justify-start w-[377px] sm:w-full">
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-20 after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <Input
            disabled
            name="fcy_amount"
            value={`${currency} ${amount_sent}`}
            className="py-4 px-[15px] disabled:border-none disabled:bg-[#FAFAFA] placeholder:text-black-900_99 sm:pr-5 text-[15px] text-left w-full"
            type="text"
          ></Input>
        </div>
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-24 after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <label
            htmlFor="refund_amount"
            className="text-sm font-medium leading-[17px]"
          >
            Refundable Amount
          </label>
          <div className="relative w-full rounded-md">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
              <span className=" font-medium leading-4 -tracking-[1%] p-2 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                {currency}
              </span>
            </div>
            <Input
              type="number"
              name="refund_amount"
              value={refundable_amount}
              onChange={(e) => {
                const value = e.target.value;
                if (Number(value) > Number(amount_sent)) {
                  toast.warning(
                    "Refundable amount can not be greater than amount sent",
                  );
                  return;
                }
                dispatch(setRefundableAmount(value));
              }}
              onWheel={(e) => {
                e.currentTarget.blur();
              }}
              id="refund_amount"
              className="m-0 h-11 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
            />
          </div>
        </div>
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-24 after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <label
            htmlFor="settlement_rate"
            className="text-sm font-medium leading-[17px]"
          >
            Settlement rate
          </label>
          <div className="relative w-full rounded-md">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
              <span className=" font-medium leading-4 -tracking-[1%] p-2 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                INR
              </span>
            </div>
            <Input
              id="settlement_rate"
              name="settlement_rate"
              value={settlement_rate}
              onWheel={(e) => {
                e.currentTarget.blur();
              }}
              onChange={(e) => {
                const value = e.target.value;
                dispatch(setRefundSettlementRate(value));
              }}
              type="number"
              className="m-0 h-11 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
            />
          </div>
        </div>
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${Number(partner_order_id) ? "after:h-28 after:border-blue-700" : ""} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <label
            htmlFor="my_margin"
            className="text-sm font-medium leading-[17px]"
          >
            My margin
          </label>
          <div className="relative w-full rounded-md">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
              <span className=" font-medium leading-4 -tracking-[1%] p-2 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                INR
              </span>
            </div>
            <Input
              type="number"
              name="my_margin"
              value={my_margin}
              onWheel={(e) => {
                e.currentTarget.blur();
              }}
              id="my_margin"
              onChange={(e) => {
                const value = e.target.value;
                dispatch(setMyMargin(value));
              }}
              className="m-0 h-11 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
            />
          </div>
          {Boolean(Number(my_margin)) && (
            <div className="py-1 px-2 bg-[#F9F9F9] flex items-center justify-between w-full">
              <p className="text-[#666666] text-sm font-normal">My income</p>
              <p className="text-[#666666] text-sm font-normal">
                {calculateProfit(
                  Number(refundable_amount),
                  Number(settlement_rate),
                  Number(my_margin),
                )}
              </p>
            </div>
          )}
        </div>
        {Number(partner_order_id) ? (
          <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
            <div
              className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${false ? "after:h-24 after:border-blue-700" : ""} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
            >
              <img
                className="relative -left-10 "
                src={`images/overview/ellipse.svg`}
                alt=""
              />
            </div>
            <label
              htmlFor="partner_margin"
              className="text-sm font-medium leading-[17px]"
            >
              Partner margin
            </label>
            <div className="relative w-full rounded-md">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
                <span className=" font-medium leading-4 -tracking-[1%] p-2 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                  INR
                </span>
              </div>
              <Input
                name="partner_margin"
                value={partner_margin}
                onWheel={(e) => {
                  e.currentTarget.blur();
                }}
                id="partner_margin"
                onChange={(e) => {
                  const value = e.target.value;
                  dispatch(setPartnerMargin(value));
                }}
                type="number"
                className="m-0 h-11 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
              />
            </div>
            {Boolean(Number(partner_margin)) && (
              <div className="py-1 px-2 bg-[#F9F9F9] flex items-center justify-between w-full">
                <p className="text-[#666666] text-sm font-normal">
                  Partner’s income
                </p>
                <p className="text-[#666666] text-sm font-normal">
                  {calculateProfit(
                    Number(refundable_amount),
                    Number(settlement_rate),
                    Number(partner_margin),
                  )}
                </p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}
